import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/features/auth/store";
import { useAuthTokenRefresh } from "@/features/auth/hooks/useAuthTokenRefresh";
import React from "react";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const token = useAuthStore((s) => s.token);
  const isLoading = useAuthStore((s) => s.isLoading);
  const firebaseUser = useAuthStore((s) => s.firebaseUser);
  const location = useLocation();
  useAuthTokenRefresh();

  // Keep the tree mounted during background token refreshes — returning null
  // here unmounts all portals (Radix Dialog, Select) and causes removeChild
  // crashes when React tries to reconcile the re-mounted tree.
  if (isLoading && !token) return null;
  if (!token) return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;

  // Catch any user who never completed profile setup (no email/password linked).
  // This handles users who bypassed /complete-profile in a previous session.
  const hasEmailPassword = firebaseUser?.providerData.some((p) => p.providerId === 'password') ?? false;
  if (firebaseUser && !hasEmailPassword) {
    return <Navigate to="/complete-profile" replace />;
  }

  return <>{children}</>;
};

